import useStyles from './ProgressBar.styles';

interface ProgressBarProps {
  percentage: number;
}

export default function ProgressBar({ percentage }: ProgressBarProps) {
  const { classes } = useStyles({
    percentageComplete: percentage,
  });
  return (
    <div className={classes.container}>
      <div className={classes.textContainer}>{`${percentage}%`}</div>
      <div className={classes.percentageCompleteBar} />
      <div className={classes.totalBar} />
    </div>
  );
}
